// Character limits for form fields
export const MAX_TEXT_LENGTH = 1_000; // 1K for single-line text fields
export const MAX_MULTILINE_TEXT_LENGTH = 5_000; // 5K for multiline text fields
export const MAX_DESCRIPTION_LENGTH = 5_000; // 5K for markdown descriptions
export const MAX_COMMENT_LENGTH = 10_000; // 10K for history comments, matches the backend limit
export const COMMENT_COUNTER_THRESHOLD = MAX_COMMENT_LENGTH - 1_000; // count only shows in the last 1K
